import request from '../axios';
import { API_ABSENCES_YEARLY_SUMMARY } from '../../constants';

export const fetchAbsencesYearlySummary = (usernames, year) =>
  request
    .get(`${API_ABSENCES_YEARLY_SUMMARY}?username=${usernames[0]}&year=${year}`)
    .then((res) => res?.data ?? null);
